var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VGridRow',[_c('VGridCol',{staticClass:"error_red"},_vm._l((_vm.errors),function(error,indexError){return _c('div',{key:indexError,on:{"click":function($event){return _vm.focusToErrorEl(error.typeField, error.indexPoint)}}},[_vm._v(" "+_vm._s(error.message)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }